import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";
import AdminSidebar from "../components/AdminSidebar";
import "../css/admin.css";

function AdminNewArrivals() {

    const [products, setProducts] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        loadProducts();
    }, []);

    const loadProducts = () => {

        axios
            .get(`${API_URL}/admin/new-arrivals`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            })
            .then((res) => {

                setProducts(res.data);

            })
            .catch(console.log);

    };

    const toggleNewArrival = (id, value) => {

        axios
            .put(
                `${API_URL}/admin/new-arrivals/${id}`,
                {
                    is_new: value ? 1 : 0
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
            )
            .then(() => {

                loadProducts();

            })
            .catch(console.log);

    };

    return (

        <div className="admin-layout">

            <AdminSidebar />

            <div className="admin-content">

                <h1>New Arrivals</h1>

                <input
                    className="admin-search"
                    placeholder="Search Product..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                <table className="admin-table">

                    <thead>

                        <tr>

                            <th>ID</th>

                            <th>Image</th>

                            <th>Product</th>

                            <th>Category</th>

                            <th>Price</th>

                            <th>New Arrival</th>

                        </tr>

                    </thead>

                    <tbody>

                        {
                            products
                                .filter((item) =>
                                    item.product_name
                                        .toLowerCase()
                                        .includes(search.toLowerCase())
                                )
                                .map((item) => (

                                    <tr key={item.id}>

                                        <td>{item.id}</td>

                                        <td>

                                            <img
                                                src={`${API_URL.replace("/api", "")}${item.image}`}
                                                alt={item.product_name}
                                                width="60"
                                            />

                                        </td>

                                        <td>{item.product_name}</td>

                                        <td>{item.category}</td>

                                        <td>₹{item.price}</td>

                                        <td>

                                            <input
                                                type="checkbox"
                                                checked={item.is_new === 1}
                                                onChange={(e) =>
                                                    toggleNewArrival(
                                                        item.id,
                                                        e.target.checked
                                                    )
                                                }
                                            />

                                        </td>

                                    </tr>

                                ))
                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

}

export default AdminNewArrivals;